import { useState } from 'react';
import { Stack, Box, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SortIcon from '@mui/icons-material/Sort';
import { SearchToolbar } from './SearchToolbar.js';
import { SortingButtons } from './SortingButtons.js';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export function StationsPageHeader({ topPadding, sortConfig, sortRows, search, setSearch }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery('(min-width:1010px)');
  const headerBackground = theme.palette.background.default;

  return isDesktop ? (
    <DesktopHeader
      topPadding={topPadding}
      headerBackground={headerBackground}
      sortConfig={sortConfig}
      sortRows={sortRows}
      search={search}
      setSearch={setSearch}
    />
  ) : (
    <MobileHeader
      topPadding={topPadding}
      headerBackground={headerBackground}
      sortConfig={sortConfig}
      sortRows={sortRows}
      search={search}
      setSearch={setSearch}
    />
  );
}

const DesktopHeader = ({ topPadding, headerBackground, sortConfig, sortRows, search, setSearch }) => (
  <Box sx={{ width: '100%', backgroundColor: headerBackground }}>
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ paddingBottom: topPadding, paddingTop: topPadding, px: 2 }}
    >
      <SortingButtons sortConfig={sortConfig} sortRows={sortRows} />
      <SearchToolbar search={search} setSearch={setSearch} />
    </Stack>
  </Box>
);

const MobileHeader = ({ topPadding, headerBackground, sortConfig, sortRows, search, setSearch }) => {
  const [openPanel, setOpenPanel] = useState(null);
  const togglePanel = (panel) => {
    setOpenPanel((prev) => (prev === panel ? null : panel));
  };

  return (
    <Box sx={{ width: '100%', backgroundColor: headerBackground }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: topPadding, paddingTop: topPadding, px: 2 }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <IconButton onClick={() => togglePanel('sorting')} size="small">
            <SortIcon />
          </IconButton>
          {openPanel === 'sorting' && <SortingButtons sortConfig={sortConfig} sortRows={sortRows} />}
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          {openPanel === 'search' && <SearchToolbar search={search} setSearch={setSearch} />}
          <IconButton onClick={() => togglePanel('search')} size="small">
            <SearchIcon />
          </IconButton>
        </Stack>
      </Stack>
    </Box>
  );
};